import { configureStore } from '@reduxjs/toolkit'
import gameReducer from './features/gameSlice';
import userPerformanceReducer from './features/userPerformanceSlice';
import authReducer from './features/authSlice'
import modalReducer from './features/modalSlice'
import profileReducer from './features/profileSlice';
import metaReducer from './features/metaSlice';

// A throwaway store for playing a custom puzzle. It is never saved to
// localStorage, so it can't touch the daily game, streaks or stats.
export const createCustomPuzzleStore = () =>
  configureStore({
    reducer: {
      gameReducer,
      userPerformanceReducer,
      authReducer,
      modalReducer,
      profileReducer,
      metaReducer,
    },
  });
